import { createElement } from 'react';
import { BLOCK_RENDERERS, type BlockType } from './puckConfig';
import type { Audience } from '@shared/schemas/audience';

export interface BlockData<T = unknown> {
  id: string;
  type: BlockType | string;
  payload: T;
  audienceFilter?: {
    segments?: string[];
    intents?: string[];
    leadStates?: string[];
    variantLabel?: string;
  } | null;
}

function matchAudience(
  filter: BlockData['audienceFilter'] | undefined,
  audience: Audience | null,
): boolean {
  if (!filter) return true;
  if (!audience) return true;

  if (filter.segments?.length && !filter.segments.includes(audience.segment)) return false;
  if (filter.intents?.length && !filter.intents.includes(audience.intent)) return false;
  if (filter.leadStates?.length && !filter.leadStates.includes(audience.leadState)) return false;
  return true;
}

export function BlockRenderer({
  blocks,
  audience = null,
}: {
  blocks: BlockData[];
  audience?: Audience | null;
}) {
  const visible = blocks.filter((b) => matchAudience(b.audienceFilter, audience));
  return (
    <>
      {visible.map((block) => {
        const Component = BLOCK_RENDERERS[block.type as BlockType];
        if (!Component) {
          if (typeof console !== 'undefined') {
            console.warn(`Unknown block type: ${String(block.type)}`);
          }
          return null;
        }
        return createElement(Component as never, {
          key: block.id,
          ...(block.payload as object),
        });
      })}
    </>
  );
}
